import api from 'helpers/api';
import { toast } from 'sonner';
import authHeader from 'helpers/auth-headers';

class OrderService {
  async createOrder(order) {
    try {
      const response = await api.post('/api/v2/orders/create', order, { headers: { ...authHeader() } });
      return { status: 'Success', message: response.data.message, balance: response.data.balance };
    } catch (error) {
      toast.error('Something went wrong', { description: 'Error creating order' });
      return { status: 'Failed' };
    }
  }

  async getOrders() {
    try {
      const response = await api.get('/api/v2/orders', { headers: { ...authHeader() } });
      return response.data;
    } catch (error) {
      toast.error('Something went wrong', { description: 'Error getting orders' });
      return [];
    }
  }

  async getDetailOrder(id) {
    try {
      const response = await api.get(`/api/v2/orders/${id}/detail`, { headers: { ...authHeader() } });
      return response.data;
    } catch (error) {
      toast.error('Something went wrong', { description: 'Error getting order detail' });
      return null;
    }
  }
}

export default new OrderService();
